export default __webpack_public_path__ + "static/media/upstaged.f760006b.png";